export enum ErrorCode {

    DepositLimits = -1,
}
